// Put your application javascript here
var initialClick = true;

var buttoncheck = setInterval(checkforbutton, 10);

function checkforbutton() {
    if (document.querySelector('#shopify-chat-dummy')) {
        clearInterval(buttoncheck);
        document.querySelector('.chat-emphasis').classList.remove('hide');
        const ShopifyChat = document.querySelector('#dummy-chat-button');
        ShopifyChat.addEventListener('click', () => {
            delayText();
        });
    } else if (document.querySelector('iframe#ShopifyChat')) {
        const ShopifyChat = document.querySelector('iframe#ShopifyChat');
        if (ShopifyChat.contentWindow.document.querySelector('button.chat-toggle')) {
            clearInterval(buttoncheck);
            document.querySelector('.chat-emphasis').classList.remove('hide');
            ShopifyChat.contentWindow.document.querySelector('button.chat-toggle').addEventListener('click', () => {
                delayText();
            });
        } else if (ShopifyChat.contentWindow.document.querySelector('.chat-app--is-open')) {
            clearInterval(buttoncheck);
            document.querySelector('.chat-emphasis').classList.remove('hide');
            changeText();
        }
    }
}
function delayText(ShopifyChat) {
    if (initialClick) {
        setTimeout(() => {
            changeText();
        }, 5000);
        initialClick = false;
    }
}
function changeText() {
    document.querySelector('.headline.default').classList.add('animated');
    setTimeout(() => {
        document.querySelector('.headline.default').style.display = 'none';
        document.querySelector('.headline.install').style.display = 'block';
        setTimeout(() => {
            document.querySelector('.headline.install').classList.add('animated');
        },50);
    }, 400);
}